import { Theme, ThemeOptions, createTheme } from '@material-ui/core';

import { darkPurple, green, lightGreen } from 'utils/color-styles';

declare module '@material-ui/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const primary = {
  50: '#ebeaff',
  100: '#cbcbff',
  200: '#a7a9ff',
  300: '#8186ff',
  400: '#6368ff',
  500: '#4649fb',
  600: '#413fef',
  700: '#3832e2',
  800: '#2f24d7',
  900: '#2900be',
  A100: '#cbcbff',
  A200: '#4649fb',
  A400: '#3832e2',
  A700: '#2900be',
  contrastDefaultColor: 'light',
  main: darkPurple,
};

const secondary = {
  main: '#C0A4E2',
};

const grey = {
  400: '#828282',
  700: '#4f4f4f',
  900: '#333',
};

const success = {
  dark: green,
  main: lightGreen,
};

const text = {
  primary: grey['900'],
};

const fontFamily = [
  'Graphik',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',');

export const themeOptions: ThemeOptions = {
  palette: {
    primary,
    secondary,
    text,
    grey,
    success,
  },
  typography: {
    fontFamily,
    fontSize: 12,
    button: {
      fontWeight: 400,
      textTransform: 'none' as const,
    },

    h1: {
      fontWeight: 700,
      fontSize: '32px',
      lineHeight: '40px',
      letterSpacing: '0.15px',
    },

    h4: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '19px',
      letterSpacing: '0.15px',
    },
  },
  props: {
    MuiButton: {
      color: 'primary' as const,
      variant: 'outlined' as const,
      disableElevation: true,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 20,
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 20,
        border: '1px solid #FAFAFC',
      },
    },
    MuiChip: {
      root: {
        fontSize: 13,
      },
    },
    MuiInputLabel: {
      root: {
        textTransform: 'uppercase' as const,
      },
      formControl: {
        transform: `translate(0, ${28 - 1}px) scale(1)`,
      },
    },
    MuiDialogActions: {
      root: {
        padding: 16,
      },
    },
  },
};

export const theme = createTheme(themeOptions);

export default theme;
